module.exports = {"210911001":"玉新街道","210911007":"玉龙街道","210911008":"玉丰街道","210911102":"四合镇","210911401":"六家子管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210911.json
// module id = 656
// module chunks = 0